export default {
  'component.tagSelect.expand': 'Развернуть',
  'component.tagSelect.collapse': 'Свернуть',
  'component.tagSelect.all': 'Все',
  'component.avatarDropdown.personalProfile': 'Личный профиль',
  'component.avatarDropdown.personalSettings': 'Личные настройки',
  'component.avatarDropdown.logout': 'Выйти',
  'component.contextSwitcher.select': 'Выберите позицию',
  'component.contextSwitcher.fallback': 'Позиция',
  'component.contextSwitcher.reset': 'Вернуться в основной профиль',
  'component.contextSwitcher.switchFailed': 'Не удалось переключить контекст',
  'component.contextSwitcher.org.methodologicalDepartment': 'Методологический отдел',
  'component.contextSwitcher.org.developmentDepartment': 'Отдел разработки',
  'component.positionGate.title': 'Выберите позицию',
  'component.positionGate.description':
    'Работа идёт от имени одной позиции: у каждой свой набор прав и свой интерфейс. Позицию можно сменить в верхней панели.',
  'component.themeSwitch.toDark': 'Ночной режим',
  'component.themeSwitch.toLight': 'Светлая тема',
  'component.workArea.drag': 'Переместить',
  'component.workArea.collapse': 'Свернуть',
  'component.workArea.expand': 'Развернуть',
  'component.workArea.empty': 'Все фреймы свёрнуты',
};
